import axios from 'axios';
import { config } from '../../../config/env';
import type { CredentialsStatus } from './types';

const CREDENTIALS_URL = `${config.jusfyBackend.apiUrl}/v2/me/credentials`;

type ApiResponse<T> = { data: T };

export async function getCredentialsStatus(): Promise<CredentialsStatus> {
  const { data } = await axios.get<ApiResponse<CredentialsStatus>>(
    `${CREDENTIALS_URL}/status`,
  );
  return data.data;
}

export async function createFirstPassword(password: string): Promise<void> {
  await axios.put<void>(`${CREDENTIALS_URL}/password`, { password });
}
